import { useSelector, useDispatch } from 'react-redux';
import { insertTrackEvent } from '@comeon/analytics';
import styled from 'styled-components';
import Icon, { ICON_SUPPORT_LINE } from '~/components/icon/index.js';
import { showSupportDialogBox } from './ducks/index.js';
import useUIContext from '~/ui/use-ui-context.ts';

const clickEventTracking = () => {
	insertTrackEvent({
		category: 'LP',
		action: 'SupportWidgetButton',
		label: 'Clicked'
	});
};
const SupportButton = styled.button`
	background-color: var(--support-button, rgba(var(--success), 1));
	border-radius: 26px;
	display: flex;
	padding: 12px;
	position: fixed;
	z-index: 16;
	&.is-small {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		bottom: 200px;
		min-width: 48px;
		min-height: 48px;
		right: -4px;
	}
	&.is-large {
		bottom: 110px;
		right: 24px;
	}
	&.sidebar-open {
		margin-right: 375px;
	}
	svg {
		fill: var(--support-button-content);
	}
	span {
		color: var(--support-button-content);
		font: var(--h4-regular);
		margin: 0 8px;
	}
`;

const FloatingSupportButtonBase = ({ buttonClassName, children }) => {
	const { showDialogBox, supportLoading } = useSelector(state => state.support);
	const { showSidebar } = useUIContext();
	const dispatch = useDispatch();
	const onButtonClick = e => {
		e.preventDefault();
		e.stopPropagation();
		clickEventTracking();
		dispatch(showSupportDialogBox(true));
	};

	return (
		(!showDialogBox || supportLoading) && (
			<SupportButton
				data-at="support-button"
				className={`${buttonClassName} ${showSidebar ? 'sidebar-open' : ''}`}
				onClick={onButtonClick}
			>
				{supportLoading ? <div className="spinner" /> : <Icon type={ICON_SUPPORT_LINE} />}
				{children}
			</SupportButton>
		)
	);
};

export default FloatingSupportButtonBase;
